/**
 * Service Worker registration and management
 */

/**
 * Register the service worker
 */
export function registerServiceWorker(): void {
  if (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    process.env.NODE_ENV === "production"
  ) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          console.log(
            "[Service Worker] Registration successful:",
            registration.scope
          );

          // Check for updates periodically
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener("statechange", () => {
                if (
                  newWorker.state === "installed" &&
                  navigator.serviceWorker.controller
                ) {
                  // New service worker available
                  console.log(
                    "[Service Worker] New version available. Refresh to update."
                  );
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error("[Service Worker] Registration failed:", error);
        });
    });
  }
}

/**
 * Unregister service worker (useful for development)
 */
export function unregisterServiceWorker(): void {
  if (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator
  ) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log("[Service Worker] Unregistered");
      })
      .catch((error) => {
        console.error("[Service Worker] Unregister failed:", error);
      });
  }
}
